import abcColoringBookThumb from '../assets/abc-coloring-book-thumb.png';
import happyTreeValleyThumb from '../assets/happy-tree-valley-thumb.png';
import mangoTreeThumb from '../assets/the-mango-tree-thumb.png';

function amazonSearchUrl(query) {
  return `https://www.amazon.com/s?k=${encodeURIComponent(query)}`;
}

export const AMAZON_ABC_BOOK_URL = 'https://www.amazon.com/dp/B0GYLHPS46';
export const AMAZON_MANGO_TREE_URL = 'https://www.amazon.com/dp/B0H3V5ZWN5';
export const AMAZON_HAPPY_TREE_VALLEY_URL = 'https://www.amazon.com/dp/B0H3V2R77B';
export const AMAZON_AVAILABLE_EYEBROW = 'Available Now on Amazon.com';

export const BUY_LABEL = 'Buy now';
export const COMING_SOON_LABEL = 'Coming soon';

export const STATUS = {
  BUY_NOW: 'buy_now',
  COMING_SOON: 'coming_soon',
};

/** Books pillar display order (subset of LIBRARY). */
export const PILLAR_BOOK_IDS = [
  'abc-jungle-adventure',
  'happy-tree-valley',
  'mango-tree',
  'a-new-friend',
  'giving-tree',
  'the-talent-show',
];

export const LIBRARY = [
  {
    id: 'abc-coloring',
    title: 'Libby the Lion & Friends ABC Coloring Book Adventure',
    tagline:
      'Color the alphabet with Libby and friends — a bright ABC adventure you can order today as her world keeps growing with new stories, friends, and fun.',
    cover: abcColoringBookThumb,
    coverAlt: 'Cover: Libby the Lion & Friends ABC Coloring Book Adventure',
    status: STATUS.BUY_NOW,
    buyUrl: AMAZON_ABC_BOOK_URL,
    amazonEyebrow: AMAZON_AVAILABLE_EYEBROW,
  },
  {
    id: 'happy-tree-valley',
    title: 'The Adventures of Libby the Lion & Friends: Happy Tree Valley',
    tagline:
      'Walk through a magical valley of smiling trees and cheerful friends — a colorful story about kindness, wonder, and adventure with Libby and her crew.',
    cover: happyTreeValleyThumb,
    coverAlt: 'Cover: The Adventures of Libby the Lion & Friends: Happy Tree Valley',
    status: STATUS.BUY_NOW,
    buyUrl: AMAZON_HAPPY_TREE_VALLEY_URL,
    amazonEyebrow: AMAZON_AVAILABLE_EYEBROW,
  },
  {
    id: 'mango-tree',
    title: 'The Adventures of Libby the Lion & Friends: The Mango Tree',
    tagline:
      'Join Libby as she picks ripe mangoes under the sun — a sweet tropical tale about sharing, friendship, and the joy of a sunny day adventure.',
    cover: mangoTreeThumb,
    coverAlt: 'Cover: The Adventures of Libby the Lion & Friends: The Mango Tree',
    status: STATUS.BUY_NOW,
    buyUrl: AMAZON_MANGO_TREE_URL,
    amazonEyebrow: AMAZON_AVAILABLE_EYEBROW,
  },
  {
    id: 'the-talent-show',
    title: 'The Adventures of Libby the Lion & Friends: The Talent Show',
    status: STATUS.COMING_SOON,
  },
  {
    id: 'a-new-friend',
    title: 'The Adventures of Libby the Lion & Friends: A New Friend',
    status: STATUS.COMING_SOON,
  },
  {
    id: 'giving-tree',
    title: 'The Adventures of Libby the Lion & Friends: The Giving Tree',
    status: STATUS.COMING_SOON,
  }
];

export const LIBRARY_BY_ID = Object.fromEntries(LIBRARY.map(book => [book.id, book]));

export function getBuyableBooks() {
  return LIBRARY.filter(book => book.status === STATUS.BUY_NOW);
}

/** Buy-now books featured in the hero carousel (order matters). */
export const HERO_BUYABLE_IDS = ['happy-tree-valley', 'abc-coloring', 'mango-tree'];

export function getHeroBuyableBooks() {
  return HERO_BUYABLE_IDS.map(id => LIBRARY_BY_ID[id]).filter(
    book => book && book.status === STATUS.BUY_NOW && book.cover
  );
}

export function getComingSoonBooks() {
  return LIBRARY.filter(book => book.status === STATUS.COMING_SOON);
}

export function getBooksForPillar() {
  return PILLAR_BOOK_IDS.map(id => LIBRARY_BY_ID[id]).filter(Boolean);
}

/** Primary hero / default buy link (first buyable book). */
export const PRIMARY_BUY_URL = getBuyableBooks()[0]?.buyUrl;
